import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import PropTypes from "prop-types";

import "./footer-b.css";

const FooterB = (props) => {
  return (
    <div className={`footer-b-thq-footer-elm ${props.rootClassName} `}>
      <div className="footer-b-thq-copyright-container-elm">
        <span className="footer-b-thq-link-elm1 Alt1-XS">
          {props.link ?? (
            <Fragment>
              <span className="footer-b-text">
                © 2026 by Feelers. All Rights Reserved. Feelers is a project
                housed under The Digit, which is part of Potato Productions.
              </span>
            </Fragment>
          )}
        </span>
        <Link to="/privacy-policy" className="footer-b-thq-link-elm2 Alt1-XS">
          {props.link1 ?? (
            <Fragment>
              <span className="footer-b-text">
                More information about our Privacy Policy.
              </span>
            </Fragment>
          )}
        </Link>
      </div>
    </div>
  );
};

FooterB.defaultProps = {
  rootClassName: "",
  link1: undefined,
  link: undefined,
  rootClassName1: "",
};

FooterB.propTypes = {
  rootClassName: PropTypes.string,
  link1: PropTypes.element,
  link: PropTypes.element,
  rootClassName1: PropTypes.string,
};

export default FooterB;
